/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoProcessDakosyXmlForTransistProcedureInput = {
    clientMutationId?: string | null;
    slug: string;
    entitySlug: string;
};
export type ProcessDakosyXmlForTransistProcedureWizardMutationVariables = {
    input: infoProcessDakosyXmlForTransistProcedureInput;
};
export type ProcessDakosyXmlForTransistProcedureWizardMutationResponse = {
    readonly infoProcessDakosyXmlForTransistProcedure: {
        readonly clientMutationId: string | null;
        readonly message: string;
    } | null;
};
export type ProcessDakosyXmlForTransistProcedureWizardMutation = {
    readonly response: ProcessDakosyXmlForTransistProcedureWizardMutationResponse;
    readonly variables: ProcessDakosyXmlForTransistProcedureWizardMutationVariables;
};



/*
mutation ProcessDakosyXmlForTransistProcedureWizardMutation(
  $input: infoProcessDakosyXmlForTransistProcedureInput!
) {
  infoProcessDakosyXmlForTransistProcedure(input: $input) {
    clientMutationId
    message
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoProcessDakosyXmlForTransistProcedurePayload",
    "kind": "LinkedField",
    "name": "infoProcessDakosyXmlForTransistProcedure",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProcessDakosyXmlForTransistProcedureWizardMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProcessDakosyXmlForTransistProcedureWizardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "070bbec479e313fffe1924ccc96509db",
    "id": null,
    "metadata": {},
    "name": "ProcessDakosyXmlForTransistProcedureWizardMutation",
    "operationKind": "mutation",
    "text": "mutation ProcessDakosyXmlForTransistProcedureWizardMutation(\n  $input: infoProcessDakosyXmlForTransistProcedureInput!\n) {\n  infoProcessDakosyXmlForTransistProcedure(input: $input) {\n    clientMutationId\n    message\n  }\n}\n"
  }
};
})();
(node as any).hash = '240b45d34f665263ac242b5a1f3f75b8';
export default node;
